import React, {Component, ReactNode} from 'react'

export type CardBackground = 'white' | 'primary' | 'secondary' | 'darker' | 'third'
type CardsConfig = Record<CardBackground, CardConfig>

interface CardConfig {
    background: string
}

interface CardProps {
    background?: CardBackground
    flat?: boolean
    className?: string
    children: ReactNode
    onClick?: () => void
}

export default class Card extends Component<CardProps> {
    cards: CardsConfig = {
        white: {background: 'bg-white'},
        primary: {background: 'bg-primary'},
        secondary: {background: 'bg-gray-50'},
        third: {background: 'bg-gray-52'},
        darker: {background: 'bg-gray-100'}
    }

    get className() {
        const {background, flat, className} = this.props
        const base = 'w-full p-5'
        const backgroundClass = background
            ? this.cards[background].background
            : 'bg-white'
        const flatClass = flat ? 'shadow-none' : 'shadow-sm'
        return `${base} ${backgroundClass} ${flatClass} ${className}`
    }

    render() {
        const {onClick} = this.props
        return (
            <div className={this.className} onClick={onClick}>
                {this.props.children}
            </div>
        )
    }
}
